import React, { useEffect, useState, useRef } from "react";

import MenuItem from "./MenuItem";
import api from "../../utils/api";
import logomenu from "../../assets/logoMenu.png";
import logomenu2 from "../../assets/menulogo3.png";
import logomenu3 from "../../assets/menulogo4.png";
import { FaSpinner } from "react-icons/fa";
import { useSelector } from "react-redux";

// Static image mapping
const staticImages = {
  "STARTERS/SIDES":
    "https://cdn.builder.io/api/v1/image/assets/d20a6fe424e248bb9a123f786a3857af/9c89053975c1972e641abfe34efe478ba5d28a5b595041af253e2304f453064b?apiKey=d20a6fe424e248bb9a123f786a3857af&",
  "MAIN COURSE": logomenu,
  DRINKS: logomenu2,
  DESSERTS: logomenu3,
};

function NavigationMenu({
  activeCategoryId,
  onCategoryChange,
  onLoadingChange,
  setDefaultCategory,
  onMenuDataChange, // New prop to pass data to the parent
}) {
  const [resturentId, setResturentID] = useState(null);

  const selectedRestaurantId = useSelector(
    (state) => state.restaurant.selectedRestaurantId
  );
  console.log(
    "🚀 ~ NavigationMenu ~ selectedRestaurantId:",
    selectedRestaurantId
  );
  console.log("🚀 ~ NavigationMenu ~ resturentId:", resturentId);

  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const sliderRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  useEffect(() => {
    const fetchResturent = async () => {
      try {
        const response = await api.get("/restaurant");
        console.log("🚀 ~ fetchResturent ~ response:", response);
        setResturentID(response?.data?.results[0]?._id || null);
      } catch (error) {
        console.error("Error fetching restaurant:", error.message);
      }
    };

    fetchResturent();
  }, []);

  useEffect(() => {
    const fetchMenuItems = async () => {
      if (!selectedRestaurantId) {
        console.error("Restaurant ID is missing");
        setLoading(false);
        return;
      }
  
      try {
        console.log("triger");
        const response = await api.get("/category", {
          params: { restaurantId: selectedRestaurantId },
        });
        console.log("🚀 ~ fetchMenuItems ~ response:", response);
  
        const items = response?.data?.results || [];
  
        // Filter out inactive categories
        const activeItems = items.filter((item) => item.isActive !== false);
  
        const itemsWithImages = activeItems.map((item) => ({
          ...item,
          image: staticImages[item.title] || "",
        }));
  
        setMenuItems(itemsWithImages);
  
        // Pass the filtered response to the parent
        if (onMenuDataChange) {
          onMenuDataChange(activeItems);
        }
  
        if (itemsWithImages.length > 0 && setDefaultCategory) {
          setDefaultCategory(itemsWithImages[0]._id, itemsWithImages[0].title);
        }
      } catch (error) {
        console.error("Error fetching menu items:", error.message);
      } finally {
        setLoading(false); // Set loading to false once the data is fetched
      }
    };
  
    fetchMenuItems();
  }, [selectedRestaurantId]);
  
  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - sliderRef.current.offsetLeft;
    scrollLeft.current = sliderRef.current.scrollLeft;
    sliderRef.current.style.cursor = "grabbing";
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX.current) * 2; // Adjust speed
    sliderRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    sliderRef.current.style.cursor = "grab";
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#AF313D] " />
      </div>
    );
  }
const data = [
  {
    _id: 1,
    title: "IoHelpOutline",

  },
  {
    _id: 2,
    title: "IoHelpOutline",

  },
  {
    _id: 3,
    title: "IoHelpOutline",

  },
  {
    _id: 4,
    title: "IoHelpOutline",

  },
  {
    _id: 5,
    title: "IoHelpOutline",

  },
  {
    _id: 6,
    title: "IoHelpOutline",

  },

]
  return (
    <nav className="flex flex-col rounded-none">
      <ul
        ref={sliderRef}
        className="flex gap-5 items-center lg:h-[97px] h-[38px] md:h-[68.98px] md:px-8 px-0 lg:py-5 w-full bg-[#AF313D]  rounded-[60px] max-md:px-5 max-md:max-w-full no-scrollbar overflow-x-auto whitespace-nowrap cursor-grab select-none"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item._id}
            label={item.title}
            icon={item.image || logomenu3}
            active={activeCategoryId === item._id}
            onClick={() => onCategoryChange(item._id, item.title)}
          />
        ))}
      </ul>
    </nav>
  );
}

export default NavigationMenu;
